import { render } from "./BannerDefaultListSectionCmp.vue?vue&type=template&id=35bdf9ab"
import script from "./BannerDefaultListSectionCmp.vue?vue&type=script&lang=js"
export * from "./BannerDefaultListSectionCmp.vue?vue&type=script&lang=js"

import exportComponent from "D:\\working\\MyCi4Vue\\myCi4Vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__